import { render, staticRenderFns } from "./CarouselParcourItem.vue?vue&type=template&id=a10e5138&scoped=true&"
import script from "./CarouselParcourItem.vue?vue&type=script&lang=js&"
export * from "./CarouselParcourItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e5138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarouselItem})
